import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { first } from 'rxjs';

export const statsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const name = control.get('name');
  const description = control.get('description');

  const authorsHelpedControl = control.get('authorsHelped');
  const booksSoldControl = control.get('booksSold');
  const titlesPublishedControl = control.get('titlesPublished');
  const yearsExperienceControl = control.get('yearsExperience');

  var isValid = false

  if (authorsHelpedControl != null && authorsHelpedControl.value != "" && booksSoldControl != null && booksSoldControl.value != "" && titlesPublishedControl != null && titlesPublishedControl.value != "" && yearsExperienceControl != null && yearsExperienceControl.value != "")  {
    isValid = true
  } else {
    isValid = false
  }

  return isValid ? null : { valid: true };
};